import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const ComponenteSnackBar = ({ open, onClose, snackMensaje, snackTipo }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
    >
      {/* <Alert onClose={onClose} severity={snackTipo}>
        {snackMensaje}
      </Alert> */}
      <Alert onClose={onClose} severity={snackTipo} sx={{ whiteSpace: 'pre-line' }}>
        {Array.isArray(snackMensaje)
          ? snackMensaje.join('\n')
          : snackMensaje}
      </Alert>

    </Snackbar>
  );
};
export default ComponenteSnackBar;